import React, { useState, memo, useImperativeHandle, forwardRef } from 'react';
import { Radio, RadioGroup } from 'appkit-react';

export const NewRadio = (props) => {
  const { onChange, value = null, options } = props;

  return (
    <RadioGroup onChange={onChange} value={value} className="radio-group">
      {options.map((o, i) => (
        <Radio key={i} value={o.text}>
          {o.text}
        </Radio>
      ))}
    </RadioGroup>
  );
};

const SingleSelection = (props, ref) => {
  const {
    values = {},
    options = [],
    steps: { setCurrentAnswer },
  } = props;
  const getText = (i) => options[i]?.text || null;
  const [index, setIndex] = useState(
    values.choice ? parseInt(values.choice) - 1 : null,
  );

  useImperativeHandle(ref, () => ({
    getValues: () => ({
      choice: index !== null ? String(index + 1) : null,
    }),
  }));

  const onChange = (_, v) => {
    const answerIndex = options.findIndex((e) => e.text === v);
    setIndex(answerIndex);
    if (typeof setCurrentAnswer === 'function') {
      setCurrentAnswer({ choice: answerIndex });
    }
  };

  if (!Array.isArray(options)) {
    return <div />;
  }

  return (
    <NewRadio onChange={onChange} value={getText(index)} options={options} />
  );
};

export default memo(forwardRef(SingleSelection));
